import React from 'react'
import './CommentBubble.scss'

const CommentBubble = ({ children }) => {
  return (
    <div className='viso-comment-bubble'>{children}</div>
  )
}

export default CommentBubble